import React from 'react';
import styles from './Loader.scss';
export const Loader = ({ inverted }) => {
    return (React.createElement("div", { className: `${styles.loader} ${inverted ? styles.inverted : ''}` }));
};
//# sourceMappingURL=Loader.js.map